module.exports = __webpack_public_path__ + "static/img/partner-dmkj.ca88796.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-dmkj.png
// module id = 2Vuz
// module chunks = 34